import axios from 'axios';
import { configRefs } from '@utils/constants';

async function getClassesRequest(user) {
  var _a;
  if (!user || user.authenticationProvider === "ekey" || !user.institution) {
    return [];
  }
  const response = await axios.get(
    `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
      "{{version}}",
      "v1"
    )}/api/v1/Unic/Institution/Classes/${encodeURIComponent(
      user.institution.id
    )}`
  );
  const knownClassIds = /* @__PURE__ */ new Set();
  return response.data.map((item) => ({
    id: item.Name,
    name: item.Name
  })).filter((it) => {
    if (knownClassIds.has(it.id)) {
      return false;
    }
    knownClassIds.add(it.id);
    return true;
  }).sort((a, b) => a.name.localeCompare(b.name, "da-DK", { numeric: true }));
}

export { getClassesRequest };
//# sourceMappingURL=request.get-classes.js.map
